import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/DocumentOptionalFields/DocumentOptionalFields.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { paths } from '../../RouterContainer';
import { useTranslation } from '../../../context/translationContext';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useEffect } from 'react';
import { DocumentOptionalFieldsForm } from '../../../forms/DocumentOptionalFields/DocumentOptionalFieldsForm';
import { COMPANY_TABS } from '../Company/UserCompaniesUpdatePage';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for document optional field creation
 */
export const DocumentOptionalFieldsCreatePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { companyId } = useParams();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.OPTIONAL_FIELDS
        }/create`,
        name: 'navigation.company-optional-fields-create',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`, {
      state: { tab: COMPANY_TABS.OPTIONAL_FIELDS },
    });

  /**
   * Handles create action for new optional field form submit.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    if (!companyId) return;
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.OPTIONAL_FIELD_CREATE,
        data: { ...values, companyId: companyId },
      });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        navigate(
          `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
            paths.OPTIONAL_FIELDS
          }/edit/${response.data.id}`,
        );
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.optional-field.headline-create')}</h1>
      <DocumentOptionalFieldsForm onSubmit={handleSubmit} onBack={handleOnBack} />
    </div>
  );
};
